import { BaseModel } from "../Generics/BaseModel"

export class ChangeUserPasswordByAdmin extends BaseModel {
  employeeId: number

  newPassword: string

  constructor(data: Partial<ChangeUserPasswordByAdmin> = {}) {
    super()

    this.employeeId = data.employeeId ?? -1

    this.newPassword = data.newPassword ?? ""
  }
}
